import { AfterViewInit, Directive, ElementRef, Renderer2 } from '@angular/core';

/** Removes ngx-bootstrap timepicker spinner links from the tab order. */
@Directive({
  selector: 'timepicker',
  standalone: true,
})
export class TimepickerTabIndexDirective implements AfterViewInit {
  constructor(
    private readonly element: ElementRef<HTMLElement>,
    private readonly renderer: Renderer2,
  ) {}

  ngAfterViewInit(): void {
    this.element.nativeElement
      .querySelectorAll('a.btn-link')
      .forEach((link) => {
        this.renderer.setAttribute(link, 'tabindex', '-1');
        this.renderer.setAttribute(link, 'aria-hidden', 'true');
      });
  }
}
